
import PropTypes from 'prop-types'

import { useFetchPractices, usePractices } from '../../redux/slices/practices'
import AsyncSelect from './AsyncSelect'

export default function PracticeSelect({ ...props }) {
  const fetchOptions = useFetchPractices('all')
  const practices = usePractices()
  const { width = 280 } = props

  return (
    <AsyncSelect
      style={{ width, flex: 1 }}
      fetchOptions={fetchOptions}
      options={practices}
      showSearch
      allowClear
      size="middle"
      optionFilterProp="children"
      placeholder="Select a practice"
      {...props}
    />
  )
}

PracticeSelect.propTypes = {
  width: PropTypes.number,
}
